import logo from '@/assets/brand/logo.webp'
import logoWhite from '@/assets/brand/logo-white.webp'
import logoNav from '@/assets/brand/logo-nav.webp'
import logoNavWhite from '@/assets/brand/logo-nav-white.webp'
import mark from '@/assets/brand/mark.webp'
import { cn } from '@/lib/utils'

/**
 * The HUMIS brand mark.
 *
 * <p>{@code full} is the lockup with the "Human Management Intelligence System" tagline, for
 * roomy surfaces like the sign-in screen; {@code nav} is the lockup without it, because at
 * sidebar height the tagline is unreadable; {@code mark} is the two-person "H" alone, for the
 * collapsed rail and anywhere square.
 *
 * <p>The navy wordmark disappears on a dark surface, so the lockups render both variants and
 * let the {@code .dark} class on {@code <html>} pick one. The mark's gradient reads on both.
 */
export function HumisLogo({
  variant = 'nav',
  className,
  alt = 'HUMIS',
}: {
  variant?: 'full' | 'nav' | 'mark'
  className?: string
  alt?: string
}) {
  if (variant === 'mark') {
    return <img src={mark} alt={alt} className={cn('object-contain', className)} draggable={false} />
  }
  const [light, dark] = variant === 'full' ? [logo, logoWhite] : [logoNav, logoNavWhite]
  return (
    <>
      <img src={light} alt={alt} className={cn('object-contain [.dark_&]:hidden', className)} draggable={false} />
      <img
        src={dark}
        alt={alt}
        className={cn('hidden object-contain [.dark_&]:block', className)}
        draggable={false}
      />
    </>
  )
}
